// TIMERS

import Environment from 'entities/Environment'

export const oldDataTimeoutInHours = 24 // (in hours)

export const storageIntervalInMs = 1000 // (in ms)

export const millisecondToRetryRequestSending = 3000

export const millisecondsBetweenMessagesAppear = 200

export const inputAnimationDelay = 600

export const mobileBreakpoint = 640

export const shortViewportBreakpoint = 340
export const checkVerificationDelay = 5000

export const sentryWhitelistUrls = [/https:\/\/.*sae-conversational\.com/]

export const buttonDataId = 'sae-conversational-button'
export const rootId = 'sae-conversational-widget'
export const scriptId = 'sae-conversational-script'

export const chatLaunchAttrName = 'data-launch-chat'

export enum UrlHashesFragments {
  SupportChat = 'support-chat',
  SupportChatNotifications = 'support-chat-notification',
}

export enum UrlGetParams {
  SupportChat = 'support-chat',
  SupportChatNotifications = 'support-chat-notification',
  ViewProduct = 'view-product',
  TriggerIntent = 'trigger-intent',
  Product = 'product',
  Tenant = 'tenant',
  Language = 'language',
  HideChatbot = 'hide-chatbot',
}

export enum MobileAppQueryParams {
  OS = 'os',
  OSVersion = 'osversion',
  Device = 'device',
  AppVersion = 'appVersion',
  LoginInfo = 'logininfo',
  URL = 'url',
  Step = 'step',
  AmountOfCards = 'cards',
  ICCSN = 'iccsn',
  TwoFA = '2fa',
  Process = 'process',
}

export enum SentryExtraKeys {
  ErrorRequestBody = 'Error body',
  FailedAnalyticsRequest = 'Failed analytics request',
}

export enum WidgetModes {
  Default = 'default',
  MobileApp = 'mobileapp',
}

export enum AppCampaign {
  Default = 'default',
  eRX = 'erx',
}

export enum AppDevices {
  Android = 'android',
  iOS = 'ios',
}

export const deviceQueryStringName = 'device'

export const myOrdersPath = '/nx/account/orders/'

export const shouldSentryInitialize =
  process.env.REACT_APP_SENTRY_DSN &&
  process.env.REACT_APP_VERSION &&
  process.env.NODE_ENV === Environment.production

export const maxFileUploadSize = 5242880 // 5 MB

export const themeTransitionDuration = 400

export const defaultUserlikeGroup = 'default'

export type StoredEventListenerKeys =
  | 'launchChatFromButtonClick'
  | 'sessionStorageSync'
